/*
  <ig-video>: plays its muted, looping <video> only while it is on screen and
  toggles the sound on tap. Only one video has sound at a time.
*/
if (!customElements.get('ig-video')) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => entry.target.toggle(entry.isIntersecting));
      }, { threshold: 0.5 })
    : null;

  customElements.define('ig-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.soundButton = this.querySelector('[data-sound]');
      if (!this.video) { if (this.soundButton) this.soundButton.hidden = true; return; }
      this.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        this.setSound(this.video.muted);
      });
      if (observer && !reduced) observer.observe(this);
      else this.video.setAttribute('controls', '');
    }
    disconnectedCallback() { if (observer) observer.unobserve(this); }
    toggle(visible) {
      if (!this.video) return;
      if (visible) {
        if (this.video.preload === 'none') this.video.preload = 'auto';
        const p = this.video.play();
        if (p && p.catch) p.catch(() => {});
      } else {
        this.video.pause();
      }
    }
    setSound(on) {
      if (on) {
        document.querySelectorAll('ig-video').forEach((el) => { if (el !== this) el.setSound(false); });
        const p = this.video.play();
        if (p && p.catch) p.catch(() => {});
      }
      this.video.muted = !on;
      this.classList.toggle('is-sound', on);
      if (this.soundButton) this.soundButton.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  });
}
